import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n";
import { X, ArrowRight, Sparkles } from "lucide-react";

const STEPS = ["tourRecipes", "tourInventory", "tourReorder", "tourStaff", "tourShifts", "tourInvoices", "tourBilling"];

export default function OnboardingTour() {
  const { t } = useI18n();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(0);

  useEffect(() => {
    if (!localStorage.getItem("tour_done")) setOpen(true);
  }, []);

  const finish = () => { localStorage.setItem("tour_done", "1"); setOpen(false); };
  if (!open || pathname !== "/app") return null;

  const key = STEPS[i];
  const last = i === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center p-4" data-testid="onboarding-tour">
      <div className="card-earth p-6 max-w-md w-full relative">
        <button onClick={finish} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground" data-testid="tour-skip"><X className="w-4 h-4" /></button>
        <div className="pill bg-accent/15 text-accent mb-3"><Sparkles className="w-3 h-3" /> {t("tourWelcome")} · {i + 1}/{STEPS.length}</div>
        <h2 className="serif text-2xl font-semibold mb-2" data-testid="tour-title">{t(`${key}Title`)}</h2>
        <p className="text-sm text-muted-foreground mb-6">{t(`${key}Desc`)}</p>
        <div className="flex justify-between items-center">
          <button onClick={finish} className="text-sm text-muted-foreground link-underline" data-testid="tour-close">{t("tourSkip")}</button>
          <div className="flex gap-2">
            {i > 0 && <button onClick={() => setI(i - 1)} className="btn-ghost text-sm" data-testid="tour-prev">←</button>}
            {!last ? (
              <button onClick={() => setI(i + 1)} className="btn-primary text-sm" data-testid="tour-next">{t("tourNext")} <ArrowRight className="w-4 h-4" /></button>
            ) : (
              <button onClick={() => { finish(); nav("/app/staff"); }} className="btn-primary text-sm" data-testid="tour-finish">{t("tourStart")}</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
